import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const userPatientTrialService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/user-patient-trial`,

  async getUnreadCounts(organizationId) {
    return viperApi.get(`${this.basePath(organizationId)}/unread-count`)
  },

  async createIfNotExists(organizationId, request) {
    return viperApi.post(`${this.basePath(organizationId)}`, request)
  }
}
